// extracted by mini-css-extract-plugin
module.exports = {"operationBody":"Operation_operationBody__3iWj9","buttons":"Operation_buttons__1e7V3"};